module.exports = __webpack_public_path__ + "img/4006a483ba9ccdeb687725cfbef4fd28.png";